export default "__VITE_ASSET__4c1ca793__"